/**
 * Storage & Files 機能で使用する型定義
 * API実装後はバックエンド側で型定義する
 */

/**
 * 機密レベル（4段階）
 */
export const ConfidentialityLevel = {
  /** 公開 */
  PUBLIC: "PUBLIC",
  /** 社内限定（デフォルト） */
  INTERNAL: "INTERNAL",
  /** 機密 */
  CONFIDENTIAL: "CONFIDENTIAL",
  /** 極秘（UI表示: Highly Confidential） */
  TOP_SECRET: "TOP_SECRET",
} as const;

export type ConfidentialityLevel =
  (typeof ConfidentialityLevel)[keyof typeof ConfidentialityLevel];

/**
 * ストレージプロバイダ種別
 */
export const ProviderType = {
  BOX: "BOX",
  GOOGLE_DRIVE: "GOOGLE_DRIVE",
  ONE_DRIVE: "ONE_DRIVE",
  DROPBOX: "DROPBOX",
} as const;

export type ProviderType = (typeof ProviderType)[keyof typeof ProviderType];

/**
 * 該当ドライブ、フォルダ、ファイルにアクセス権限のあるメンバー情報（ストレージ上のユーザー情報）
 */
export type Member = {
  /** ID台帳上で管理しているID */
  proxyUserId: string;
  /** ログインID（メールアドレス等） */
  loginId: string;
  /** 表示名 */
  displayName: string | null;
  /** アバター画像URL */
  avatarUrl: string | null;
  /** 外部ユーザーか */
  isExternal: boolean;
  /** Person紐付け（あれば） */
  personId: string | null;
};
